import moment from 'moment'
import states from '../helpers/USStates'
export default {
  /**
   * Validates the input string based on its type and
   * returns true/false if it passes
   * @param {string} type
   * @param {string} value
   * @returns {boolean}
   */
  validate(value, type) {
    switch (type) {
      case 'ein':
      case 'ssn':
      case 'tin':
        const strippedValue = value.replace(/-/g, '')
        return /^\d+$/.test(strippedValue) && strippedValue.length === 9
      case 'shortDate':
        return moment(value, 'MM/DD', true).isValid()
      case 'standardDate':
        return moment(value, 'MM/DD/YYYY', true).isValid()
      case 'zip':
        return /^\d+$/.test(value) && value.length === 5
      case 'number':
        return /^\d+$/.test(value)
      case 'state':
        return Boolean(states.find(([_, abbreviation]) => abbreviation === value))
      case 'name':
        return value.split(' ').length >= 2
      case 'text':
        return value.length > 0
      default:
        if (typeof value === 'string') {
          return value.length > 0
        } else if (typeof value === 'number') {
          return !Number.isNaN(value)
        }
        break
    }
  }
}